import { BffApiClientMolecule } from "@/app/api-client/store"
import { computed } from "@reatom/core"
import { molecule } from "bunshi"
import { getDropActivityQueryParams } from "../store/drop-activity-query"
import { DropIdScope } from "../store/scope"

export const DropActivityMoleculeReatom = molecule((mol, scope) => {
  const { dropId } = scope(DropIdScope)
  const bffApiClient = mol(BffApiClientMolecule)

  // Computed: drop activity query params for TanStack Query
  const dropActivityQueryParams = computed(
    () => ({
      ...getDropActivityQueryParams(bffApiClient, { id: dropId }),
      refetchInterval: 5000,
    }),
    "dropActivityQueryParams",
  )

  return { dropActivityQueryParams }
})
